export default function AcessoNegado() {
    return (
        <div className="flex h-[full] w-full justify-center py-5">
            <div className="bg-background flex flex-col items-center justify-center px-6 ">
                <div className="text-center">
                    <h1 className="font-display text-6xl font-extrabold text-destructive drop-shadow-lg">
                        403
                    </h1>

                    <h2 className="font-display mt-4 text-3xl font-bold text-destructive">
                        Acesso Negado
                    </h2>

                    <p className="mt-3 text-muted-foreground max-w-md">
                        Você não tem permissão para visualizar esta página.
                        Se acredita que isso é um engano, entre em contato com o administrador.
                    </p>

                    <div className="mt-5">
                        <a
                            href="/"
                            className="px-6 py-3 rounded-lg bg-destructive hover:brightness-95
                       text-destructive-foreground font-semibold shadow-md transition-all duration-150"
                        >
                            Voltar para tela inicial
                        </a>
                    </div>
                </div>

                {/* Efeito decorativo assustador */}
                <div className="mt-8 animate-pulse">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-24 w-24 text-destructive opacity-40"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2}
                            d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20 10 10 0 000-20z"
                        />
                    </svg>
                </div>
            </div>
        </div>
    );
}
